import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useContext, useState } from "react";
import { userContext } from "src/context/userContext";
import LazyLoader from "../layout/Progress/LazyLoader";

export default function ShowChildren({ suspense = false, ...props }) {
  const { user } = useContext(userContext) || {};
  // eslint-disable-next-line no-unused-vars
  const { children, txt, source, criteriaTxt, criteriaBool, description } = props;
  // get boolean
  const _criteriaBool =
    criteriaBool === "true" ? true : criteriaBool === "false" ? false : criteriaBool;
  const showChildren = _criteriaBool;

  const [hidden, setHidden] = useState(false);

  const isDeveloper = user.settings.isDeveloper;

  const hideKlik = () => {
    setHidden(true);
  };

  return (
    <>
      {isDeveloper && !hidden && (
        <div onClick={hideKlik} style={{ width: "100%" }}>
          <Typography variant="body2" color="secondary">
            {source}:{txt}
          </Typography>
          <Typography variant="caption" color="secondary">
            {criteriaTxt}
          </Typography>
        </div>
      )}
      {showChildren && (suspense ? <LazyLoader>{children}</LazyLoader> : children)}
    </>
  );
}

ShowChildren.propTypes = {
  children: PropTypes.node,
  criteriaBool: PropTypes.any,
  criteriaTxt: PropTypes.string,
  source: PropTypes.string,
  txt: PropTypes.string,
  suspense: PropTypes.bool,
  description: PropTypes.string,
};

// USAGE:
/**
 * 
   <ShowChildren
          txt="txt"
          source="source"
          criteriaTxt="criteriaTxt"
          criteriaBool={true}
          description="description">
          <div>children</div>
        </ShowChildren>

  <ShowChildren
              source="EditAsiakas"
              criteriaBool={asiakas && allowEditAsiakas}
              criteriaTxt="allowEditAsiakas">
 */
